export enum Browsers {
    AMIGO = 'amigo',
    CHROME = 'chrome',
    EDGE = 'edge',
    FIREFOX = 'firefox',
    GAMEROOM = 'gameroom',
    IE = 'ie',
    OPERA = 'opera',
    SAFARI = 'safari',
    YANDEX = 'yandex'
}
